export const COMPANYLIST_SEARCH = 'COMPANYLIST_SEARCH';
export const COMPANYLIST_PAGE = 'COMPANYLIST_PAGE';
export const COMPANYLIST_COMPANYTYPE = 'COMPANYLIST_COMPANYTYPE';
export const COMPANYLIST_VIACOMPANYID = 'COMPANYLIST_VIACOMPANYID';
